import { BookOpenCheck, ScrollText, Sparkles } from "lucide-react";
import { Reveal, SectionHeading } from "./common";
import { OPERE } from "../data/content";

const BADGE_STYLES = {
  Documentato: "bg-espresso text-ivory",
  Tradizione: "bg-gold text-ink",
  Leggenda: "bg-transparent text-terracotta border border-terracotta/50",
};

const LEGEND_ITEMS = [
  {
    icon: BookOpenCheck,
    label: "Documentato",
    text: "Attestato da fonti storiche, documenti o studi accademici.",
  },
  {
    icon: ScrollText,
    label: "Tradizione",
    text: "Tramandato dalla memoria storica locale, senza piena conferma documentaria.",
  },
  {
    icon: Sparkles,
    label: "Leggenda",
    text: "Racconto devozionale non verificabile: prezioso come testimonianza culturale, non come fatto storico.",
  },
];

export const Opere = () => (
  <section id="opere" className="relative grain bg-ivory py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="max-w-3xl">
        <SectionHeading
          eyebrow="Capitolo IV"
          title="Le Opere e i Tesori"
          testid="section-opere-title"
        />
        <Reveal delay={0.15}>
          <p className="mt-8 text-base sm:text-lg text-taupe leading-relaxed">
            Tra reliquie venerate, racconti devozionali e capolavori
            documentati, la Basilica custodisce tesori di natura diversa. Per
            rigore storico, ognuno è contrassegnato in base al tipo di fonte
            che lo riguarda.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.2}>
        <div className="mt-10 grid sm:grid-cols-3 gap-4 bg-sand border border-stone p-6 sm:p-8">
          {LEGEND_ITEMS.map(({ icon: Icon, label, text }) => (
            <div key={label} className="flex items-start gap-4">
              <Icon size={22} strokeWidth={1.6} className="text-gold mt-0.5 flex-shrink-0" />
              <div>
                <span className="font-mono text-xs tracking-[0.2em] uppercase text-espresso font-medium">
                  {label}
                </span>
                <p className="mt-1 text-sm text-taupe leading-relaxed">{text}</p>
              </div>
            </div>
          ))}
        </div>
      </Reveal>

      <div className="mt-12 grid md:grid-cols-2 gap-5">
        {OPERE.map((opera, i) => (
          <Reveal key={opera.id} delay={(i % 2) * 0.08}>
            <article
              data-testid={`opera-card-${opera.id}`}
              className="h-full bg-sand border border-stone hover:border-gold/70 transition-colors duration-500 p-7 sm:p-9"
            >
              <span
                className={`inline-block font-mono text-[11px] tracking-[0.2em] uppercase px-3 py-1.5 rounded-full ${BADGE_STYLES[opera.badge]}`}
              >
                {opera.badge}
              </span>
              <h3 className="mt-4 font-serif text-xl sm:text-2xl font-semibold text-espresso">
                {opera.title}
              </h3>
              <p className="mt-3 text-base text-taupe leading-relaxed">{opera.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
